export default "<div id=\"map\" class=\"map\"></div>";